import { createAsyncThunk } from '@reduxjs/toolkit';

import type { SavingsInsightsSummaryDto } from '../types/ReportSavingsSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSavingsSummaryParams {
    dateFrom: string;
    dateTo: string;
    propertyIds?: string[];
    categoryIds?: string[];
}

export const fetchSavingsSummary = createAsyncThunk<
    SavingsInsightsSummaryDto,
    FetchSavingsSummaryParams,
    ThunkConfig<string>
>(
    'reportSavingsSummary/fetchSavingsSummary',
    async ({ dateFrom, dateTo, propertyIds, categoryIds }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const response = await extra.api.post<SavingsInsightsSummaryDto>(
                '/v1/reports/savings-insights/summary',
                {
                    dateFrom,
                    dateTo,
                    ...(propertyIds?.length
                        ? {
                              propertyIds,
                          }
                        : {}),
                    ...(categoryIds?.length
                        ? {
                              categoryIds,
                          }
                        : {}),
                },
            );
            return response.data;
        } catch {
            return rejectWithValue('error');
        }
    },
);
